/* eslint-disable no-unused-vars */
import { ethers } from "ethers";
import { useContext, useEffect } from "react";
import { AppContext } from "../scripts/context";
import toast from "react-hot-toast";
import {
  A_SECTION,
  B_SECTION,
  CONNECT_METAMASK,
  C_SECTION,
  D_SECTION,
  E_SECTION,
  F_SECTION,
  G_SECTION,
  HTTP_PER_PAGE,
  PER_PAGE,
} from "../constants";
import { endpoints } from "../utils/networks";
import axiosInstance, { request } from "../admin/plugins/axios";
import {
  getPaginationAttributes,
  GetLocalStorag,
  SaveLocalStorag,
} from "../Helper/Helper";
import { useAccount, useSignMessage } from "wagmi";

export function useConnectMetaMask({ setConnectWalletModal } = {}) {
  const { address } = useAccount();
  const { data: signer, signMessageAsync } = useSignMessage();
  const {
    getWeb3,
    setState,
    TOKEN_User,
    setTOKEN_User,
    setUserData,
    initState,
    setFollowData,
    loading,
    setLoading,
    setEvent,
    setEventFillter,
    perPage,
    page,
    setPagination_options,
    setEventCategories,
    CategoriesId,
    location,
    date_From,
    date_To,
    keyword,
    history,
    owned,
    setAllNftFillter,
    setPagination_Options,
    per_Page,
    inPage,
    fillterKeyword,
    statusNft,
    price_from,
    price_to,
    condition,
    CategoriesIdNft,
    setNft_A_Section,
    setNft_B_Section,
    setNft_C_Section,
    setNft_D_Section,
    setNft_E_Section,
    setNft_F_Section,
    setNft_G_Section,
    setOwnerOfNft,
    setPagination_OptionsOwn,
    inPageOwn,
    updateNetWork,
    chainId,
    isToken,
    setIsToken,
    setRequiresProfileCompletion,
  } = useContext(AppContext);
  /*  This function to return address,message,signature from MetaMask ,use to get the user token for api | khaled Mofeed  */
  const getSignWithMetaMaskData = async () => {
    const updateAndGetMessage = async () => {
      const response = await request(
        endpoints.TeleversUserApi.GetSignMessage.method,
        endpoints.TeleversUserApi.GetSignMessage.url,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      return response.data.data;
    };

    const messageObj = await updateAndGetMessage();
    console.log("before sign", messageObj);
    const messageToSign =
      typeof messageObj?.message === "string"
        ? messageObj.message
        : typeof messageObj === "string"
        ? messageObj
        : JSON.stringify(messageObj || "");
    let signature;
    try {
      signature = await signMessageAsync({ message: messageToSign });
    } catch (signError) {
      const msg =
        signError?.message ||
        signError?.shortMessage ||
        signError?.info?.error?.message ||
        (signError?.code === 4001 ? "Request rejected" : "Signing failed");
      throw new Error(typeof msg === "string" ? msg : "Connection cancelled");
    }

    console.log("signature", signature);

    return {
      address: address,
      message: messageObj.message,
      signature: signature,
    };
  };

  /*  function for submit Connect wallet by MetaMask | khaled Mofeed | 5/12/2022 */
  const submitConnectMetaMask = async () => {
    /*  check if MetaMask extintion is not installed | khaled Mofeed | 5/12/2022 */
    // if (!CONNECT_METAMASK) {
    //   toast.error("Metamask is not installed, please install it to complete the process");
    //   return;
    // }
    setLoading(true);
    let data = {};
    /*  after check if MetaMask extintion is installed , setState , set address and method and set getWeb3 | khaled Mofeed | 5/12/2022 */
    try {
      data = await getSignWithMetaMaskData();
      setState({ loading: true });
      await getWeb3(data.address);
    } catch (error) {
      setState({ loading: false });
      setLoading(false);
      const raw = error?.message || error?.shortMessage;
      const nested = error?.info?.error?.message || error?.data?.message;
      const message = raw || nested || (typeof error === "string" ? error : "Connection cancelled or failed");
      toast.error(message);
      return;
    }
    try {
      console.log("🔐 [LOGIN] Starting login process...");
      const res = await request(
        endpoints.TeleversUserApi.LoginByAddress.method,
        endpoints.TeleversUserApi.LoginByAddress.url,
        data
      );

      const token = res.data?.data?.token;
      if (!token) {
        throw new Error("Authentication token not returned");
      }

      console.log("🔐 [LOGIN] ✅ Token received from API:", {
        token: token.substring(0, 20) + "...",
        fullToken: token,
      });

      SaveLocalStorag("UserToken", token);
      setTOKEN_User(token);
      SaveLocalStorag("connectStatus", "1");
      axiosInstance.defaults.headers.common["Authorization"] = token.includes(
        "Bearer"
      )
        ? token
        : `Bearer ${token}`;

      console.log("🔐 [LOGIN] Token saved to localStorage and state");

      // Wait a bit to ensure axios interceptor picks up the new token
      await new Promise((resolve) => setTimeout(resolve, 100));

      // Check initial user state from login response
      const loginUser = res.data?.data?.user;
      const hasEmail = Boolean(loginUser?.email?.trim());

      console.log("🔐 [LOGIN] User data from login response:", {
        wallet_address: loginUser?.wallet_address,
        name: loginUser?.name,
        email: loginUser?.email,
        hasEmail: hasEmail,
        userType: hasEmail ? "👤 Existing User" : "🆕 New User",
      });

      if (hasEmail) {
        // User has email - set token and let useEffect fetch profile data
        setRequiresProfileCompletion(false);
        setIsToken(true);
        console.log("🔐 [LOGIN] 👤 Existing User - Login successful:", {
          requiresProfileCompletion: false,
          isToken: true,
          token: token.substring(0, 20) + "...",
          email: loginUser?.email,
          name: loginUser?.name,
        });
        toast.success(res.data?.message || "Logged in successfully");
      } else {
        // User needs to complete profile
        setRequiresProfileCompletion(true);
        setIsToken(false);
        console.log("🔐 [LOGIN] 🆕 New User - Profile completion required:", {
          requiresProfileCompletion: true,
          isToken: false,
          token: token.substring(0, 20) + "...",
        });
        toast.success("Wallet connected. Please complete your profile.");
      }
    } catch (error) {
      const apiMessage =
        error.response?.data?.message ||
        error.response?.data?.errors?.address?.[0];

      toast.error(apiMessage || "Login failed");
    } finally {
      setLoading(false);
    }
  };
  /*  This function to return the profile data of this address of MetaMask ,by using the user token returned from getSignWithMetaMaskData function | khaled Mofeed  */
  const getProfileData = async () => {
    const storedToken = GetLocalStorag("UserToken");

    // Verify token matches current TOKEN_User state
    if (storedToken !== TOKEN_User) {
      console.warn("📥 [GET_PROFILE_DATA] ⚠️ Token mismatch, skipping fetch:", {
        storedToken: storedToken
          ? storedToken.substring(0, 20) + "..."
          : "No token",
        TOKEN_User: TOKEN_User
          ? TOKEN_User.substring(0, 20) + "..."
          : "No token",
      });
      return;
    }

    if (!storedToken) {
      console.warn("📥 [GET_PROFILE_DATA] ⚠️ No token found, skipping fetch");
      return;
    }

    console.log("📥 [GET_PROFILE_DATA] Starting to fetch profile data:", {
      hasToken: Boolean(storedToken),
      token: storedToken.substring(0, 20) + "...",
      isToken: isToken,
    });

    // Update axios headers (interceptor should handle this, but ensure it's set)
    axiosInstance.defaults.headers["Authorization"] = storedToken.includes(
      "Bearer"
    )
      ? storedToken
      : `Bearer ${storedToken}`;

    try {
      const response = await request(
        endpoints.ProfileData.GetProfileData.method,
        endpoints.ProfileData.GetProfileData.url
      );

      const user = response.data.data.user;
      const hasEmail = Boolean(user?.email?.trim());

      // Verify token still matches (prevent race conditions)
      const currentToken = GetLocalStorag("UserToken");
      if (currentToken !== storedToken) {
        console.warn(
          "📥 [GET_PROFILE_DATA] ⚠️ Token changed during fetch, ignoring response"
        );
        return;
      }

      console.log("📥 [GET_PROFILE_DATA] ✅ Profile data received:", {
        wallet_address: user?.wallet_address,
        name: user?.name,
        email: user?.email,
        hasEmail: hasEmail,
        token: storedToken.substring(0, 20) + "...",
      });

      // Check if email is missing - require profile completion
      if (!hasEmail) {
        console.log(
          "📥 [GET_PROFILE_DATA] ⚠️ No email found, requiring profile completion"
        );
        setRequiresProfileCompletion(true);
        setIsToken(false);
      } else {
        console.log("📥 [GET_PROFILE_DATA] ✅ Email found, profile complete");
        setRequiresProfileCompletion(false);
        setIsToken(true);
      }

      setUserData(user);
      setState({
        ...initState,
        user: {
          address: user.wallet_address,
          avatar: user.avatar,
          name: user.name,
          bio: user.bio,
          cover: user.cover,
          twitter: user.twitter,
          facebook: user.facebook,
          portfolio: user.portfolio,
          linkedin: user.linkedin,
          instagram: user.instagram,
          custom_url: user.custom_url,
          following_count: user.following_count,
          followers_count: user.followers_count,
        },
        loading: false,
      });

      setLoading(false);
    } catch (error) {
      console.error("❌ [GET_PROFILE_DATA] Failed to fetch profile data:", {
        error: error?.response?.data || error?.message,
        token: storedToken.substring(0, 20) + "...",
      });

      // Only clear token if it's an authentication error
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        localStorage.removeItem("connectStatus");
        localStorage.removeItem("UserToken");
        setIsToken(false);
        setRequiresProfileCompletion(false);
      }

      setLoading(false);
    }

    setFollowData({
      followings: [],
      followers: [],
    });
  };
  /*  This function to request event data | khaled Mofeed  */
  const getEventData = async () => {
    setState({ ...initState, loading: true });

    try {
      const response = await request(
        endpoints.Event.GetAll.method,
        endpoints.Event.GetAll.url,
        {
          params: {
            paginate: perPage,
            page,
            categories: CategoriesId,
            location: location,
            from: date_From,
            to: date_To,
            keyword: keyword,
            history: history,
            owned: owned,
          },
        }
      );

      const { events, pagination_options } = response.data.data;
      setEvent({
        event: events,
      });
      setPagination_options({
        Pagination_options: pagination_options.options,
        Pagination_Count: pagination_options.count,
        Pagination_Total: pagination_options.total,
      });
    } catch (error) {
      console.error("Error fetching event data", error);
    }
  };
  /*  request to get NFT data by fillter | khaled Mofeed  */
  const getAllNftByFillter = async () => {
    let filterNFT = "";
    /*  Define the variables to be used in the filter | khaled Mofeed  */
    const queryParams = {
      per_page: per_Page,
      page: inPage,
      category_id: CategoriesIdNft,
      location: location,
      filter: fillterKeyword,
      status: statusNft,
      price_from: price_from,
      price_to: price_to,
      condition: condition,
    };
    /* Give each variable its own value | khaled Mofeed  */
    for (const key in queryParams) {
      const value = queryParams[key];
      if (value) {
        if (Array.isArray(value)) {
          filterNFT += value.map((val) => `${key}[]=${val}`).join("&");
        } else {
          filterNFT += `${key}=${value}`;
        }
        filterNFT += "&";
      }
    }
    /* Return variables in a single handle variable | khaled Mofeed  */
    filterNFT = filterNFT.slice(0, -1); // remove the last '&'

    const get_All_Nft_Fillter = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + `?${filterNFT}`,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setAllNftFillter({
      allNftFillter: get_All_Nft_Fillter[0]?.data?.data?.nfts,
    });
    /*  request to get NFT data Of A_Section For Map | khaled Mofeed  */
    const get_Nft_A_Section = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + A_SECTION,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setNft_A_Section(get_Nft_A_Section[0]?.data?.data?.nfts);
    /*  request to get NFT data Of B_Section For Map | khaled Mofeed  */
    const get_Nft_B_Section = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + B_SECTION,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setNft_B_Section(get_Nft_B_Section[0]?.data?.data?.nfts);
    /*  request to get NFT data Of C_Section For Map | khaled Mofeed  */
    const get_Nft_C_Section = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + C_SECTION,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setNft_C_Section(get_Nft_C_Section[0]?.data?.data?.nfts);
    /*  request to get NFT data Of D_Section For Map | khaled Mofeed  */
    const get_Nft_D_Section = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + D_SECTION,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setNft_D_Section(get_Nft_D_Section[0]?.data?.data?.nfts);
    /*  request to get NFT data Of E_Section For Map | khaled Mofeed  */
    const get_Nft_E_Section = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + E_SECTION,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setNft_E_Section(get_Nft_E_Section[0]?.data?.data?.nfts);
    /*  request to get NFT data Of F_Section For Map | khaled Mofeed  */
    const get_Nft_F_Section = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + F_SECTION,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setNft_F_Section(get_Nft_F_Section[0]?.data?.data?.nfts);
    /*  request to get NFT data Of G_Section For Map | khaled Mofeed  */
    const get_Nft_G_Section = await Promise.all([
      request(
        endpoints.Marketplace.AllInNftWithOutAuth.method,
        endpoints.Marketplace.AllInNftWithOutAuth.url + G_SECTION,
        {
          params: {
            getAll: 1,
          },
        }
      ),
    ]);
    setNft_G_Section(get_Nft_G_Section[0]?.data?.data?.nfts);
    /*  use Helper getPaginationAttributes to handle the data of paginations | khaled Mofeed  */
    const paginationAttributesNft = getPaginationAttributes(
      get_All_Nft_Fillter[0]?.data?.data
    );
    setPagination_Options({
      Pagination_options: paginationAttributesNft.options,
      Pagination_Count: paginationAttributesNft.count,
      Pagination_Total: paginationAttributesNft.total,
    });
  };
  useEffect(() => {
    console.log("🔄 [USE_EFFECT] Token or isToken changed:", {
      TOKEN_User: TOKEN_User ? TOKEN_User.substring(0, 20) + "..." : "No token",
      isToken: isToken,
      willFetchProfile: isToken && TOKEN_User,
    });

    // Only fetch profile data if we have a token and isToken is true
    // This prevents duplicate requests and ensures we use the correct token
    if (isToken && TOKEN_User) {
      const storedToken = GetLocalStorag("UserToken");

      // Verify token matches before fetching
      if (storedToken === TOKEN_User) {
        console.log(
          "🔄 [USE_EFFECT] Token verified, triggering getProfileData..."
        );
        getProfileData();
      } else {
        console.warn("🔄 [USE_EFFECT] ⚠️ Token mismatch, skipping fetch:", {
          storedToken: storedToken
            ? storedToken.substring(0, 20) + "..."
            : "No token",
          TOKEN_User: TOKEN_User.substring(0, 20) + "...",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TOKEN_User, isToken]);

  /*  useEffect to run getEventByFillter function by token | khaled Mofeed  */
  // useEffect(() => {
  //   if (isToken) {
  //     getEventByFillter();
  //   }
  // }, [
  //   TOKEN_User,
  //   page,
  //   CategoriesId,
  //   location,
  //   date_From,
  //   date_To,
  //   keyword,
  //   history,
  //   owned,
  //   loading,
  //   isToken,
  // ]);
  /*  useEffect to run getAllNftByFillter function || khaled Mofeed  */
  // useEffect(() => {
  //   getAllNftByFillter();
  // }, [
  //   inPage,
  //   CategoriesIdNft,
  //   location,
  //   fillterKeyword,
  //   statusNft,
  //   price_from,
  //   price_to,
  //   condition,
  //   per_Page,
  // ]);

  /*  run and export submitConnectMetaMask function | khaled Mofeed | 5/12/2022 */
  return submitConnectMetaMask;
}
